// import './loader.scss'

function init() {

    console.log("hello loader");

 
}

export default init